/**
 *  Plan getters module file
 **/

import { PlanState } from './state'

export const getters = {
  getMetadata: (state: PlanState) => state.metadata,
  getPlan: (state: PlanState) => state.plan,
  getPlanFilters: (state: PlanState) => state.plan.filters,
  getAssetsMeta: (state: PlanState) => state.assets.meta,
  getAssetsCount: (state: PlanState) => state.assets.count,
  getSubplanFiltersIndex: (state: PlanState) => state.activeSubPlanFiltersIndex,
  getLegendFilter: (state: PlanState) => state.plan.legend,
  getAssetsFinishedLoad: (state: PlanState) => state.assetsFinishedLoad,
  getAssetsIdsLayerVisibility: (state: PlanState) =>
    state.plan.legend.assetsIdsLayerVisibility,
  getColorizeAssets: (state: PlanState) => state.plan.legend.colorizeAssets,
  getAssetsDetails: (state: PlanState) => state.assetsDetails,
  getAssetsReadyWithAllProperties: (state: PlanState) =>
    state.assetsReadyWithAllProperties,
  getPackagesData: (state: PlanState) => state.packages,
  getPackagesPriceRange: (state: PlanState) =>
    state.plan.package.filter.priceRange,
  getPackagesDateRange: (state: PlanState) =>
    state.plan.package.filter.dateRange,
  getPackagePrice: (state: PlanState) => state.plan.package.price?.totalNet,
  getPackageGrossPrice: (state: PlanState) =>
    state.plan.package.price?.grossPrice,
  getPackage: (state: PlanState) => state.plan.package,
  getPackageState: (state: PlanState) => state.plan.package.state,
  getForceLogout: (state: PlanState) => state.forceLogout,
  getPackagesFilter: (state: PlanState) => state.plan.package.filter,
  getAssetsAngleNorthMap: (state: PlanState) => state.plan.legend.angleNorthMap,
  getAssetsDigitalStaticProperties: (state: PlanState) =>
    state.assetsProperties,
  getPlansComments: (state: PlanState) => state.plans.comments.data,
  getPlansCommentsLastUpdate: (state: PlanState) =>
    state.plans.comments.updatedAt,
  getMyPlans: (state: PlanState) => state.plans.user,
  getPublicPlans: (state: PlanState) => state.plans.public,
  getPlansClients: (state: PlanState) => state.plans.clients,
  getIsSubscribedToComments: (state: PlanState) =>
    state.plans.comments.subscribed,
  getLatestPlansCommentsUpdated: (state: PlanState) =>
    state.plans.comments.latest_plans_updated,
  getIsSubscribedToPlans: (state: PlanState) => state.plans.subscribed,
  getEditingPlan: (state: PlanState) => state.plan.editing,
  getOriginFeaturedPackage: (state: PlanState) =>
    state.plan.originFeaturedPackage,
  getIsFeaturedPackageAdminDetail: (state: PlanState) =>
    state.isFeaturedPackageAdminDetail,
  getFeaturedPackageAdminDetailSourceTab: (state: PlanState) =>
    state.featuredPackageAdminDetailSourceTab,
}
